import React from 'react';
import {LayoutPortal} from '../../LayoutPortal';
import {DashboMCPContent} from '../dashbo_mcp/DashboMCPContent';

export const PortalDashboMCP = () => {
    return (
        <LayoutPortal>
            <div className="portal-embedded-page">
                <DashboMCPContent />
            </div>
        </LayoutPortal>
    );
};
